export interface IVinValidationContext {
  vin: string
  group: string
  checkedStatus?: string;
  exception?: string;
  year?: string;
  make?: string;
  model?: string;
  gcw?: string;
  gvw?: string;
}

export function VehicleWeightClassCode(context: IVinValidationContext): string {
  if (!!context.gcw && Number(context.gcw) > 0) {
    if (Number(context.gcw) > 45000) {
      return 'XHVY_TT';
    }
    return 'HVY_TT';
  }
  else if (!!context.gvw && Number(context.gvw) > 10000) {
    if (Number(context.gvw) > 45000) {
      return 'XHVY_TRK';
    }
    else if (Number(context.gvw) > 20000) {
      return 'HVY_TRK';
    }
    return 'MED_TRK';
  }
  return '';
}